import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import env from '@/env';
import { AuditInvitationDetail } from '@/common';

export const getAuditInvitationById = async (
  id: string,
  lang: string
): Promise<AuditInvitationDetail> => {
  const fetchResponse = await fetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/audit-invitations/${id}?${new URLSearchParams({
      lang,
    })}`,
    {
      method: 'GET',
      headers: {
        authenticate: localStorage.getItem('accessToken') || '',
      },
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as AuditInvitationDetail;
  return response;
};
